const TOKEN_KEY = 'token'

const existsToken = () => {
    try {
        return !!uni.getStorageSync(TOKEN_KEY)
    } catch (error) {
        return false;
    }
}

const getToken = () => {
    try {
        return uni.getStorageSync(TOKEN_KEY)
    } catch (error) {
        return ""
    }
}

const setToken = (token: string) => {
    try {
        uni.setStorageSync(TOKEN_KEY, token)
    } catch (error) {
        // ignore error
    }
}

const clearToken = () => {
    try {
        uni.removeStorageSync(TOKEN_KEY)
    } catch (error) {
        // ignore error
    }
}

export {existsToken, getToken, setToken, clearToken}
